// Localized

// TODO multiple selection for filters

import SubHeader from "@/components/SubHeader";
import Button from "@/components/button";
import Input from "../../components/input";
import axios from "@/axios";
import Loader from "@shared/loader";
import GroupModal from "./create-group-modal.vue";
import Dropdown from "@shared/components/dropdown-base";
import Table from "@shared/dashboard-components/table-large";
import { checkPermission } from "@shared/utils/functions";
import { caseEntityTypesMap } from "@shared/modules/localization/utils/caseEntityTranslation/constants";
import { translateEntity } from "@shared/modules/localization/utils/caseEntityTranslation";
import { getFilterOptions, getSearchParams } from "@shared/dashboard-components/table-large/utils";
import { paginationOptions } from "@shared/dashboard-components/table-large/utils/constants";

export default {
    name: "group-table",
    components: {
        SubHeader,
        Button,
        Input,
        GroupModal,
        Loader,
        Dropdown,
        Table,
    },
    created() {
        // return this.$route.path;
    },
    title: "Groups",

    data() {
        return {
            loading: false,
            showInputTypeModal: false,
            groupname: "",
            clients: "",
            noOfUsers: "",
            groupdescription: "",
            active: true,
            items: [],
            tenant_id: null,
            searchTimeout: 500,
            pageData: {
                total: 0,
            },
            serverParams: null,
            columnFilterOptionsAsync: {},
            currentPageData: {
                page: 1,
                count: 10,
            },
            paginationOptions: { ...paginationOptions },
            searchLoading: {},
        };
    },
    computed: {
        filterOptions() {
            let result = this.getFilterOptions(this.columns, this.items);
            return result;
        },
        paginatedItems() {
            const { page, count } = this.currentPageData;
            const start = (page - 1) * count;
            const end = start + count;
            return this.items.slice(start, end);
        },
        translatedItems() {
            return this.paginatedItems.map(this.translateEntity);
        },
        columns() {
            return [
                {
                    label: this.$t('pages.group_details.group_name'),
                    field: "title",
                    config: {
                        filter: {
                            nameModifier: (el) => this.translateEntity(el).title,
                            multi: true,
                        },
                        template: "link",
                    }, 
                    query_key: "name", 
                    sortable: true,
                },
                {
                    label: this.$t('pages.group_details.no_of_users'),
                    field: "user_count",
                    sortable: false,
                },
                {
                    label: this.$t('pages.group_details.group_description'),
                    field: "description",
                    config: {
                        filter: {
                            nameModifier: (el) => this.translateEntity(el).description,
                            multi: true,
                        },
                    }, 
                    sortable: true,
                },
            ].map((el) => ({
                ...el,
                config: { 
                    ...el.config, 
                    isLoading: !!this.searchLoading[el.field] || false 
                }
            }));
        },
    },
    async mounted() {
        this.tenant_id = this.$store.getters.getTenantId;
        this.items = await this.getGroups();
        this.pageData.total = this.items.length;
    },
    methods: {
        getFilterOptions,
        checkPermission,
        translateEntity(entity) {
            return translateEntity(entity, caseEntityTypesMap.GROUP);
        },
        async addGroup() {
            this.groupname = this.groupname.trim();
            this.groupdescription = this.groupdescription.trim();
            if(this.groupname.length === 0 || this.groupdescription.length===0)
            {
                return;
            }
            try {
                let { data } = await axios.post("group/tenant", {
                    title: this.groupname,
                    description: this.groupdescription,
                    active: this.active,
                    tenant_id: this.tenant_id,
                });
                this.$toast.success(data.message || this.$t('pages.group_details.success_group_created'));
                this.items.push({
                    title: this.groupname,
                    description: this.groupdescription,
                    user_count: 0,
                    id: data.group_id,
                });
                console.log(data, "asasas");
                this.$router.push({
                    name: "Group Setting",
                    params: {
                        id: data.group_id,
                    },
                });
                this.hanldeCloseModal();
            } catch (error) {
                this.$toast.error(error.response.data.detail || this.$t('pages.group_details.error_delete_group'));
            }
        },
        async getGroups(params = {}) {
            let items = [];
            try {
                this.loading = true;
                const searchParams = getSearchParams(this.serverParams);
                let { data } = await axios.get(`group/tenant/${this.tenant_id}`, { params: { ...searchParams, ...params } } );
                items = data;
            } catch (error) {
                console.log("error", error);
            }
            this.loading = false;
            return items;
        },
        hanldeCloseModal() {
            this.$modal.hide("group-modal");
        },
        async handleShowModal() {
            await this.$store.dispatch("fetchPermissions");
            if(!this.checkPermission('groups.create')) {
                this.$toast.error(this.$t('pages.group_details.error_no_permission_create_group'));
                return;
            }
            this.selectedField = null;
            this.$modal.show("group-modal");
        },
        handleRowClick(data) {
            this.$router.push({
                name: "Group Setting",
                params: {
                    id: data.id,
                    ...data,
                },
            });
        },
        // Filters
        async updateColumnFilters(column, value /* , callback */) {

            if(this.selectedOptions[column.label]){
                this.selectedOptions = {...this.selectedOptions,[column.label]:[...value]};
            }
            else
                this.selectedOptions = {...this.selectedOptions,[column.label]:[...value]}

            let selected = {
                key: column.filterOptions.query_key || column.field,
                value: column.filterOptions.multi ? value.map((el) => el.name) : [value?.name],
            };
            if (!selected.value?.length) {
                delete this.selectedDropDownItems[selected.key];
                this.items = await this.getGroups();
                this.pageData.total = this.items.length;
                return this.items;
            }

            this.selectedDropDownItems = { ...this.selectedDropDownItems, [selected.key]: selected.value };
            let newLists = await this.filterListDropdownItem();
            this.items = newLists;
            this.pageData.total = newLists.length;
        },
        async filterListDropdownItem(params) {
            this.loading = true;
            let url = `group/tenant/groups`;
            let items = null;
            let filterParams = {};
            if (this.serverParams) {
                filterParams = getSearchParams(this.serverParams);
            }
            try {
                const body = {
                    tenant_id: this.tenant_id,
                    ...filterParams,
                    ...params
                };
                const { data } = await axios.post(url, body);
                items = data.data;
                this.pageData = data?.page_data
            } catch (error) {
                console.log(error, "<<<<error while fetching users");
            }
            this.loading = false;
            console.log("filterListDropdownItem params", params); // TODO remove
            console.log("filterListDropdownItem items", items); // TODO remove
            return items;
        },
        searchFilter(payload) {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            const delay = 500;
            this.searchTimeout = setTimeout(() => {
                this.getSearchOptions(payload);
            }, delay);
        },
        async getSearchOptions(payload) {
            // if searching is canceled reset async filter options for the field:
            if (!payload.value) this.columnFilterOptionsAsync = null;
            else {
                // set 'loading' prop for the column we are searching in:
                this.$set(this.searchLoading, payload.column.field, true);
                try {
                    // combine current search value with selected filter params:
                    const searchParams = getSearchParams(this.serverParams, payload);
                    const filteredItems = await this.getGroups(searchParams);
                    this.columnFilterOptionsAsync = this.getFilterOptions(this.columns, filteredItems);
                } catch (error) {
                    console.log("error :>> ", error);
                }

                this.$set(this.searchLoading, payload.column.field, false);
            }
        },
        async onSortChange(data) {
            console.log("onSortChange", data); // TODO remove
            if (data && data.length && data[0].type !== "none") {
                data = data[0];
                let sortParams = {
                    sort: data.field + ":" + data.type,
                }
                this.items = await this.filterListDropdownItem(sortParams)

            } else {
                this.items = await this.filterListDropdownItem()
            }
            this.pageData.total = this.items.length;
        },
        async onPageChange(data, reset = false) {
            let { currentPerPage, currentPage } = data;
            this.currentPageData = {
                page: currentPage,
                count: currentPerPage,
            };
            if (reset) this.currentPageData.page = 1;
            const scrollTarget = document.getElementById('groupList');
            if (scrollTarget) {
              scrollTarget.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
        },
        async clearFilters() {
            this.paginationOptions.perPage = this.currentPageData.count
            this.serverParams = null;
            this.items = await this.getGroups();
            this.pageData.total = this.items.length;
        },
        async onColumnFilters({ columnFilters }) {
            this.currentPageData.page = 1
            this.paginationOptions.perPage = this.currentPageData.count
            this.serverParams = columnFilters ? { ...columnFilters } : null;
            this.items = await this.getGroups();
            this.pageData.total = this.items.length;
        },
    },
};
